



















































































































































































































interface Ware {
  id: number;
  thumbnail: string;
  name: string;
  price: number;
  price_text: string;
  type: string;
  type_text: string;
  type_secondary: string;
  type_secondary_text: string;
  stock: number;
  stock_total: number;
  sale_volume: number;
  create_time: Moment;
  create_time_text: string;
  commission_one_self: string;
  commission_one_two: string;
  commission_two: string;
  index_show_text: string;
  redeem_code_total: string;
  redeem_code_total_real: string;
  redeem_code_released: string;
  redeem_code_unreleased: string;
}

import { Component, Prop, Vue } from 'vue-property-decorator';
import moment, { Moment } from 'moment';
import { dateTime, date } from '@/util/adapter';
import { AxiosResponse } from 'axios';
const dateFormat = require('bmh/date-format');
const numeral = require('numeral');
const getUrl = require('bmh/url-with-param');
const { VUE_APP_API } = process.env;
const API = {
  query: `${VUE_APP_API}/qy/ware/detail/query`,
  detail: `${VUE_APP_API}/qy/ware/redeemCode/index`,
  import: `${VUE_APP_API}/qy/ware/redeemCode/import`,
  export: `${VUE_APP_API}/qy/ware/redeemCode/export`,
  delete: `${VUE_APP_API}/qy/ware/redeemCode/delete`,
};

function getWare(remote?: any): Ware {
  remote = remote || {};
  const numeral_price = numeral(remote.price || 0).divide(100);
  return {
    id: remote.id,
    thumbnail: (remote.banner_url_list || [])[0] || '',
    name: remote.name || '',
    price: numeral_price.value(),
    price_text: numeral_price.format('0.00'),
    type: remote.type,
    type_text: remote.type === 1 ? '实物' : '虚拟',
    type_secondary: remote.type_secondary,
    type_secondary_text: remote.type_secondary === 1 ? '/兑换码' : '/无',
    stock: remote.current_stock,
    stock_total: remote.stock_total,
    sale_volume: remote.sales,
    create_time: moment(remote.create_time),
    create_time_text: dateTime(moment(remote.create_time)),
    commission_one_self: remote.commission_one_self,
    commission_one_two: remote.commission_one_two,
    commission_two: remote.commission_two,
    index_show_text: remote.index_show === 1 ? '展示' : '不展示',
    redeem_code_total: remote.redeem_code_total,
    redeem_code_total_real: remote.redeem_code_total_real,
    redeem_code_released: remote.redeem_code_released,
    redeem_code_unreleased: remote.redeem_code_unreleased,
  };
}
@Component
export default class EditFirst extends Vue {
  is_loading: boolean = false;
  ware_id: any = '';
  detail_data: Ware[] = [];
  table_data: RemotePagination<any> = {
    current_page: 1,
    last_page: 1,
    per_page: 1,
    total: 0,
    data: [],
  };
  page: number = 1;
  is_show_import: boolean = false;
  api: any = API;
  file_list: any = [];

  dateFormat(time: any) {
    return dateFormat(new Date(time * 1000), '%Y-%m-%d %H:%M:%S');
  }

  handChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getDetail(next_page);
  }

  paginationOption(data: RemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.per_page}条`,
      pageSize: data.per_page || 1,
      current: data.current_page || 1,
    };
  }

  async query() {
    const res = await this.$axios.get(`${API.query}?id=${this.ware_id}`);
    if (res.data.error !== 0) {
      this.$message.error(res.data.message);
      return;
    }
    this.detail_data = [getWare(res.data.data)];
  }

  async getDetail(page: any) {
    this.page = page;
    const res = await this.$axios.get(
      `${API.detail}?ware_id=${this.ware_id}&page=${page}`,
    );
    if (res.data.error !== 0) {
      this.$message.error(res.data.message);
      return;
    }
    this.table_data = res.data.data;
  }

  beforeUpload(file: any) {
    this.file_list = [file];
    return false;
  }

  handleRemove(file: any) {
    const index = this.file_list.indexOf(file);
    const newFileList = this.file_list.slice();
    newFileList.splice(index, 1);
    this.file_list = newFileList;
  }

  async handleUpload() {
    const { file_list, ware_id } = this;
    if (file_list.length === 0) {
      this.$message.error('请选择要上传的文件');
      return false;
    }
    const form_data = new FormData();
    form_data.append('file', file_list[0]);
    form_data.append('ware_id', ware_id);
    const res = await this.$axios.post(API.import, form_data);
    if (res.data.error !== 0) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('导入成功');
    this.is_show_import = false;
    this.file_list = [];
    await this.getDetail(1);
  }

  exportData() {
    window.location.href = getUrl(API.export, {
      ware_id: this.ware_id,
    });
  }

  async delete(id: any) {
    const res = await this.$axios.get(`${API.delete}?id=${id}`);
    if (res.data.error !== 0) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('删除成功');
    await this.getDetail(this.page);
  }

  showConfirm(id: any) {
    const _this = this;
    this.$confirm({
      title: '确认是否删除',
      onOk() {
        _this.delete(id);
      },
    });
  }

  async created() {
    this.is_loading = true;
    this.ware_id = this.$route.params.id;
    Promise.all([this.query(), this.getDetail(1)])
      .then((result: any) => {
        console.log(result);
      })
      .catch((error: any) => {
        console.log(error);
      });
    this.is_loading = false;
  }
}
